<template>
<edit-record-container 
	:columns="columns">
	<div slot-scope="{item}" class="mt15">
		<div v-if="type=='person'">
			<FileShow :url="item.subjectMatterUrls" title="雇佣合同" v-if="item.subjectMatterUrls"/>
		</div>
		<div v-if="type=='car'" v-for="(car, index) in item.extraInfo" :key="index" class="ml15">
			<FileShow :url="car.drivingLicensePhotoFront" :title="car.carNumber"/>
			<FileShow :url="car.drivingLicensePhotoEnd" :title="car.carNumber"/>
		</div>
	</div>
</edit-record-container>
</template>
<script>
import EditRecordContainer from '@/pages/haierProduct/components/common/EditRecordContainer'
import FileShow from '@/components/common/FileShow'
export default {
	components:{ EditRecordContainer,FileShow },
	data () {
		return {
			bizId:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE',
			amount:'',
			type:this.$route.params.type||'',
			columns:[]
		}
	},
	computed:{
		productCode(){
			return this.type=='person'?'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE':'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_TRUCK'
		}
	},
	created() {
		this.initData()
	},
	methods:{
		initData(){
			if(this.type=='person'){
				this.columns=[
					{title: '序号',type: 'index',width:70,align:'center'},
					{title: '保障方案',key: 'scheme',minWidth:150},
					{title: '保费（元）',key: 'premium',width:120},
					{title: '姓名',key: 'insuredPersonName',minWidth:100},
					{title: '证件号码',key: 'idCard',minWidth:190},
					{title: '性别',key: 'gender',width:70},
					{title: '年龄',key: 'age',width:70},
					{title: '保障起期',key: 'effectiveDateStart',width:120},
					{title: '保障止期',key: 'effectiveDateEnd',width:120},
					{title: '备注',key: 'remark',width:160},
				]
			}else{
				this.columns=[
					{title: '序号',type: 'index',width:70,align:'center'},
					{title: '保障方案',key: 'scheme',width:180},
					{title: '座位数',key: 'seatingCapacity',width:80},
					{title: '保费（元）',key: 'premium',width:120},
					{title: '车牌号',key: 'carNumber',minWidth:120},
					{title: '发动机号',key: 'engineNumber',minWidth:190},
					{title: '车架号',key: 'frameNumber',minWidth:180},
					{title: '保障起期',key: 'effectiveDateStart',width:120},
					{title: '保障止期',key: 'effectiveDateEnd',width:120},
					{title: '备注',key: 'remark',width:160},
				]
			}
		},
		getHeight(url){

		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/EditRecord.vue